import { Injectable } from '@angular/core';
import { DropdownOption } from '../forms/inputs/dropdown/dropdown.component';

export enum Tenant {
  APFELSINIA = 'apfelsinia',
  VHV_SHU = 'vhv-shu',
  PRO_GLOBAL = 'pro-global',
  INTER_EUROPE = 'inter-europe',
  VGH_SD_K_3 = 'vgh-sd-k-3',
  CONTINENTALE = 'continentale',
  EUROPA = 'europa',
  EUROPA_GO = 'europa-go',
  CONTINENTALE_UNFALL = 'continentale-unfall',
  EUROPA_UNFALL = 'europa-unfall',
  NV_VERSICHERUNG = 'nv-versicherung',
  VAN_AMEYDE = 'van-ameyde',
  BARMENIA = 'barmenia',
  R_UND_V = 'r-und-v',
  R_UND_V_DIREKT = 'r-und-v-direkt',
  KRAVAG_ALLGEMEINE = 'kravag-allgemeine',
  KRAVAG_LOGISTIC = 'kravag-logistic',
  OEVO = 'oevo',
  LAWYER = 'lawyer',
  BARMENIA_UNFALL = 'barmenia-unfall',
  BARMENIA_AH = 'barmenia-ah',
  UNIVERSA = 'universa',
  SPARKASSENVERSICHERUNG = 'sparkassenversicherung',
  HDI_BH = 'hdi',
  HDI_KH = 'hdi-kh',
  HDI_HW = 'hdi-hw',
  SHB = 'shb',
  VHV = 'vhv',
  NUERNBERGER = 'nuernberger',
  BAYERISCHE = 'bayerische',
  AGILA = 'agila',
  VERTI = 'verti',
  FAHRLEHRER = 'fahrlehrer',
  ITZEHOER = 'itzehoer',
  ADMIRAL = 'admiral',
  PROVINZIAL_DUESSELDORF = 'provinzial-duesseldorf',
  PROVINZIAL_MUENSTER = 'provinzial-muenster',
  PROVINZIAL_NORD = 'provinzial-nord',
  HAMBURGER_FEUERKASSE = 'hamburger-feuerkasse',
  SIGNAL_IDUNA_AH = 'signal-iduna-ah',
  SIGNAL_IDUNA_KH = 'signal-iduna-kh',
  ADLER_AH = 'adler-ah',
  ADLER_KH = 'adler-kh',
  PVAG_AH = 'pvag-ah',
  PVAG_KH = 'pvag-kh',
  DEBEKA = 'debeka',
  DEBEKA_VIP = 'debeka-vip',
  WUERTTEMBERGISCHE = 'wuerttembergische',
}

const proofOrderTenants: Map<Tenant, string> = new Map<Tenant, string>([
  [Tenant.INTER_EUROPE, 'Inter Europe'],
  [Tenant.VGH_SD_K_3, 'VGH SD-K-3'],
  [Tenant.NV_VERSICHERUNG, 'NV Versicherung'],
  [Tenant.VAN_AMEYDE, 'Van Ameyde'],
  [Tenant.BARMENIA, 'Barmenia'],
  [Tenant.OEVO, 'ÖVO'],
  [Tenant.UNIVERSA, 'uniVersa'],
  [Tenant.SPARKASSENVERSICHERUNG, 'Sparkassenversicherung'],
  [Tenant.HDI_BH, 'HDI (BH)'],
  [Tenant.HDI_KH, 'HDI (KH)'],
  [Tenant.HDI_HW, 'HDI (HW)'],
  [Tenant.SHB, 'SHB'],
  [Tenant.VHV, 'VHV-KKS'],
  [Tenant.NUERNBERGER, 'Nuernberger'],
  [Tenant.BAYERISCHE, 'Bayerische'],
  [Tenant.AGILA, 'AGILA'],
  [Tenant.VERTI, 'Verti'],
  [Tenant.FAHRLEHRER, 'Fahrlehrer'],
  [Tenant.ITZEHOER, 'Itzehoer'],
  [Tenant.ADMIRAL, 'Admiral'],
  [Tenant.PROVINZIAL_DUESSELDORF, 'Provinzial Düsseldorf'],
  [Tenant.PROVINZIAL_MUENSTER, 'Provinzial Münster'],
  [Tenant.PROVINZIAL_NORD, 'Provinzial Nord'],
  [Tenant.HAMBURGER_FEUERKASSE, 'Hamburger Feuerkasse'],
  [Tenant.SIGNAL_IDUNA_AH, 'SI AH'],
  [Tenant.SIGNAL_IDUNA_KH, 'SI KH'],
  [Tenant.ADLER_AH, 'Adler AH'],
  [Tenant.ADLER_KH, 'Adler KH'],
  [Tenant.PVAG_AH, 'PVAG AH'],
  [Tenant.PVAG_KH, 'PVAG KH'],
  [Tenant.WUERTTEMBERGISCHE, 'Württembergische'],
]);

export const TENANTS_WITH_MANDATORY_BUSINESS_TRANSACTION = new Set([
  'inter-europe',
  'apfelsinia',
  'barmenia',
  'barmenia-ah',
  'continentale',
  'barmenia-unfall',
  'debeka',
  'debeka-vip',
  'nv-versicherung',
  'van-ameyde',
  'shb',
  'nuernberger',
  'fahrlehrer',
  'itzehoer',
]);

@Injectable({
  providedIn: 'root',
})
export class TenantsService {
  getTenantDropdownOptions(): DropdownOption<string>[] {
    return proofOrderTenants
      .entries()
      .map(([value, label]) => {
        return { value, label };
      })
      .toArray()
      .sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        } else if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
  }
}
